// TODO: Move validate massage from common.js
export default {
  '{name} is required.': '{name}を入力してください。',
  Required: '必須',

  'Please enter a number.': '数字を入力してください。',
  'Please enter a number smaller than {number}.': '{number}以下の数字を入力してください。',
  '{number} or less': '{number}以下',
  'Please enter a number greater than {number}.': '{number}以上の数字を入力してください。',
  '{number} or more': '{number}以上',

  'Please enter a {name}.': '{name}を入力してください。',
  '{name} must be between {min} and {max}.': '{min}〜{max}の範囲で入力してください。',
  '{name} must be within {min} to {max} characters.':
    '{name}は{min}文字以上、{max}文字以内で入力してください。',
  'Please enter within {number} characters.': '{number}文字以内で入力してください。',
  '{number} letters or less': '{number}文字以内',
  'Please enter at least {number} characters.': '{number}文字以上で入力してください。',
  '{number} letters or more': '{number}文字以上',

  'Please select {name}.': '{name}を選択してください。',
  'Please enter an integer.': '整数を入力してください。',
};
